import ThemeToggle from "../common/ThemeToggle";
import BrandLogo from "../common/BrandLogo";

function AuthShell({ children }) {
  return (
    <div className="relative min-h-screen overflow-x-hidden overflow-y-auto bg-[#F8F6F2] transition-colors duration-500 dark:bg-[#111827] flex items-center justify-center py-12 px-5 sm:px-8">
      <div className="relative w-full max-w-[500px] flex flex-col items-center">
        <div className="w-full rounded-[32px] bg-white/90 dark:bg-[#1F2937] backdrop-blur-[12px] p-2 shadow-2xl dark:shadow-2xl dark:shadow-black/50 border border-[#E5E7EB] dark:border-[#4B5563] transition-colors duration-500">
          <div className="relative flex flex-col items-center pt-10 pb-2">
            <div className="absolute top-6 right-6">
              <ThemeToggle />
            </div>
            <BrandLogo size="lg" />
          </div>
          <div className="h-full w-full animate-in fade-in slide-in-from-bottom-4 duration-700">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthShell;
